import { createContext } from "react";

const conversationContext = createContext();

export default conversationContext;
